export default{
    v3_portal_url: function(state){
        return state.v3_portal_url;
    },
    branch: function(state){
        return state.branch;
    },
    entryURL: function(state){
        return state.entryURL;
    },
    session_id: function(state){
        return state.session_id;
    },
    mode: function(state){
        return state.mode;
    },
    api: function(state){
        return state.api;
    },
    baseURL: function(state){
        return state.baseURL;
    },
    ready: function(state){
        return state.ready;
    },
    csrf : function(state){
        return state.csrf;
    },
    jwt : function(state){
        return state.jwt;
    },
    user : function(state){
        return state.user;
    },
    language : function(state){
        return state.language;
    },
    overlays : function(state){
        return state.overlays;
    },
    busy : function(state){
        return state.busy;
    },
    window: function(state){
        return state.window;
    },
    programs: function(state){
        return state.programs;
    },
    progressBar: function(state){
        return state.progressBar;
    },
    programStatus : function(state){
        return state.programStatus;
    },
    library: function(state){
        return state.library;
    },
    sessionLoggedDuration: function(state){
        return state.userSession ? state.userSession.loggedDuration : 0;
    },
    sessionCreated: function(state){
        return state.userSession.created;
    },
    sessionUpdated: function(state){
        return state.userSession.updated;
    },
    sessionLoggedTrackingStarted: function(state){
        return state.userSession.loggedTrackingStarted;
    },
    sessionLastActivity: function(state){
        return state.userSession.lastActivity;
    },
    userSession: function(state){
        return state.userSession;
    },
    siteRegulationTargetTab: function(state){
        return state.siteRegulationTargetTab;
    },
    V3_PortalState: function(state){
        return state.V3_PortalState;
    },
    v4_media_url: function(state) {
        return state.v4_media_url;
    },
    featuredProgramId: function(state) {
        return state.featuredProgramId;
    },
    environment: function(state){
        return state.environment;
    },
    getCompanyName: function(state) {
        return state.companyName;
    },
    specialties: function(state) {
        return state.specialties;
    }
  } 